import api from "../core/http";

/**
 * Get User stats for profile page
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const getUserStats = (userHandle, year) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return api
    .get(`/v1/user/stats${!!userHandle ? `/${userHandle}` : ""}`, {
      params: { timezone, ...(year ? { year } : {}) },
    })
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Get User info
 * - uses react-query
 *
 * @returns
 */
export const getUserInfo = () => {
  return api
    .get("/user")
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Get the authenticated user's comic notes.
 */
export const getUserNotes = () => {
  return api.get("/v1/user/notes").then((res) => res.data);
};

/**
 * Get User profile
 * - uses react-query
 *
 * @returns
 */
export const getUserProfile = (userHandle) => {
  return api
    .get(`/v1/user/${userHandle}`)
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Get User stats for profile page
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const subscriptionCheck = () => {
  return api
    .get("/v1/user/subscription-check")
    .then((res) => res.data)
    .catch((err) => err);
};

export const getPaywall = () => {
  return api
    .get("/v1/user/paywall")
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Get Payment intent
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const paymentIntent = () => {
  return api
    .get("/v1/subscriptions/payment-intent")
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Get All billing info
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const getBilling = () => {
  return api
    .get("/v1/subscriptions")
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Cancel subscription
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const cancelSubscription = () => {
  return api
    .post("/v1/subscriptions/cancel")
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * resume subscription
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const resumeSubscription = () => {
  return api
    .post("/v1/subscriptions/resume")
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Get User stats for profile page
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const deleteAccount = (userId) => {
  return api
    .delete("/user/account")
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Update user handle
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const updateUserHandle = (userHandle) => {
  return api
    .post("/v1/user/update-handle", { userHandle })
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Update profile picture
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const updateProfilePicture = (profilePicture, type = "file") => {
  const formData = new FormData();
  formData.append("type", "file");
  if (profilePicture) {
    formData.append("profile_picture", profilePicture);
  }

  return api
    .post("/v1/user/update-profile-picture", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data)
    .catch((err) => err);
};
